import $ from "jquery";

export default function heroSection() {
   const $html = $("html");
   const $scroller = $("html, body");

   if ($("#hero.hero").length) {
      $(function(){
         $("#hero .canvas").remove();
         $("#hero .marquee").removeClass("-has-canvas");
         setTimeout(function(){
            $("#hero .marquee").addClass("-play");
         }, 100);
      });
   }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/hero.js